const colors = {
  'background':    '#0F1117',   // deep navy-black
  'surface':       '#161B27',   // slightly lighter for cards
  'terracotta':    '#E07A5F',   // muted warm accent (replaces living-coral)
  'steel-blue':    '#5B9BD5',   // clean secondary (replaces brilliant-blue)
  'slate':         '#8892B0',   // muted text / dates
  'sage':          '#7FBFBF',   // soft teal highlight (replaces limpet-shell)
  'off-white':     '#CCD6F6',   // primary text, softer than pure white

  // kept for any legacy references
  'living-coral':  '#E07A5F',
  'brilliant-blue':'#5B9BD5',
  'limpet-shell':  '#7FBFBF',
  'dark-charcoal': '#0F1117',
};

export default colors;
